import 'intersection-observer'; // eslint-disable-line
import 'details-element-polyfill'; // eslint-disable-line
